module.exports = __webpack_public_path__ + "images/exit-team-success-cd91b54a32c63ec2ce3edea99e0e889c.jpg";